
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[[...slug]]",
      function () {
        return require("private-next-pages/[lang]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[[...slug]]"])
      });
    }
  